import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { adObjectEntity } from './index';

/**
 * ADOU entity - alias of ADObject
 * Represents Active Directory Organizational Unit objects
 */
export const adOUEntity: QueryEntity<unknown> = {
  ...adObjectEntity,
  primaryLabel: { actual: 'ADOU', display: 'AD OU' },
  alias: 'ADObject',
};
